import {
  LIST_SERVICE_ITEM_REQUEST,
  LIST_SERVICE_ITEM_SUCCESS,
  LIST_SERVICE_ITEM_FAILURE,
  LIST_SERVICE_ITEM_RESET,
  CREATE_SERVICE_ITEM_REQUEST,
  CREATE_SERVICE_ITEM_SUCCESS,
  CREATE_SERVICE_ITEM_FAILURE,
  DETAIL_SERVICE_ITEM_REQUEST,
  DETAIL_SERVICE_ITEM_SUCCESS,
  DETAIL_SERVICE_ITEM_FAILURE,
  UPDATE_SERVICE_ITEM_REQUEST,
  UPDATE_SERVICE_ITEM_SUCCESS,
  UPDATE_SERVICE_ITEM_FAILURE,
  DELETE_SERVICE_REQUEST,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAILURE,
  SUMMARY_SERVICE_ITEM_REQUEST,
  SUMMARY_SERVICE_ITEM_SUCCESS,
  SUMMARY_SERVICE_ITEM_FAILURE,
  SUMMARY_SERVICE_ITEM_WITH_PARENT_SUCCESS,
  POSITION_SERVICE_ITEM_REQUEST,
  POSITION_SERVICE_ITEM_SUCCESS,
  POSITION_SERVICE_ITEM_FAIL
} from '../../constants/service-items'

const initialState = {
  loading: false,
  serviceItems: [],
  serviceItem: {},
  summaryServiceItem: [],
  summaryServiceItemWithParent:[],
  error: ''
}

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_ITEM_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SERVICE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceItems: action.payload
      }
    case LIST_SERVICE_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        serviceItems: [],
        error: action.payload
      }
    case LIST_SERVICE_ITEM_RESET:
      return {
        ...state,
        loading: false,
        serviceItems: [],
        error: ''
      }
    case CREATE_SERVICE_ITEM_REQUEST:
      return {
        ...state,
        loading: true
      }
    case CREATE_SERVICE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case CREATE_SERVICE_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        service: {},
        error: action.payload
      }
    case DETAIL_SERVICE_ITEM_REQUEST:
      return {
        ...state,
        loadingCreate: true,
        serviceItem: {}
      }
    case DETAIL_SERVICE_ITEM_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        serviceItem: action.payload
      }
    case DETAIL_SERVICE_ITEM_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        serviceItem: {},
        error: action.payload
      }
    case SUMMARY_SERVICE_ITEM_REQUEST:
      return {
        ...state,
        loadingCreate: true,
        summaryServiceItem: [],
        summaryServiceItemWithParent:[]
      }
    case SUMMARY_SERVICE_ITEM_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        summaryServiceItem: action.payload
      }
    case SUMMARY_SERVICE_ITEM_WITH_PARENT_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        summaryServiceItemWithParent: action.payload
      }
    case SUMMARY_SERVICE_ITEM_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        summaryServiceItem: [],
        error: action.payload
      }
    case UPDATE_SERVICE_ITEM_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SERVICE_ITEM_SUCCESS:
      return {
        ...state,
        loadingUpdate: false
      }
    case UPDATE_SERVICE_ITEM_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        service: {},
        error: action.payload
      }
    case DELETE_SERVICE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case POSITION_SERVICE_ITEM_REQUEST:
      return { ...state, loadingPosition: true }
    case POSITION_SERVICE_ITEM_SUCCESS:
      return { ...state, loadingPosition: false }
    case POSITION_SERVICE_ITEM_FAIL:
      return { ...state, loadingPosition: false, error: action.payload }
    case DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        services: state.services
      }
    case DELETE_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        service: {},
        error: action.payload
      }
    default:
      return state
  }
}

export default serviceReducer

